module.exports = __webpack_public_path__ + "img/receive-gifts-img.7d803a8d.png";